import { CartItem } from "../state/cart";
import { fetchOptionsByIds } from "./options";
import { fetchProductsByIds, Product } from "./products";

const parseVariant = (compositeId: string) => {
  const [productId, sizeKey = "", tasteKey = ""] = (compositeId || "").split(
    "::"
  );
  const tasteId = tasteKey.startsWith("taste:") ? tasteKey.slice(6) : null;
  return { productId, sizeKey: sizeKey || null, tasteId };
};

const getBasePriceFromProduct = (p: Product, sizeKey: string | null) => {
  if (
    sizeKey &&
    p.size &&
    p.size[sizeKey] &&
    p.size[sizeKey][0]?.price != null
  ) {
    return Number(p.size[sizeKey][0].price);
  }
  return Number(p.price);
};

export async function repriceCartItems(items: CartItem[]) {
  if (!items.length)
    return { latestById: new Map<string, number>(), changed: [] as string[] };

  const productIds = Array.from(
    new Set(items.map((i) => parseVariant(i.id).productId).filter(Boolean))
  );
  const tasteIds = Array.from(
    new Set(
      items
        .map((i) => parseVariant(i.id).tasteId)
        .filter((x): x is string => Boolean(x))
    )
  );

  const [rawProducts, tasteOptions] = await Promise.all([
    fetchProductsByIds(productIds),
    fetchOptionsByIds(tasteIds),
  ]);

  const productsMap = new Map<string, Product>(
    rawProducts.map((p) => [p.id, p])
  );
  const tasteMap = new Map<string, { price: number }>(
    tasteOptions.map((o) => [String(o._id), { price: Number(o.price || 0) }])
  );

  const latestById = new Map<string, number>();
  const changed: string[] = [];

  for (const it of items) {
    const { productId, sizeKey, tasteId } = parseVariant(it.id);

    const prod = productsMap.get(productId);
    if (!prod) continue;

    const base = getBasePriceFromProduct(prod, sizeKey);
    const tasteDelta = tasteId ? tasteMap.get(tasteId)?.price || 0 : 0;
    const latest = Number((base + tasteDelta).toFixed(2));

    latestById.set(it.id, latest);

    const current = typeof it.price === "number" ? it.price : Number(it.price);

    if (Number(current.toFixed(2)) !== latest) {
      changed.push(it.id);
    }
  }

  return { latestById, changed };
}
